/****   request.js   ****/
// 导入axios
import axios from 'axios'
//import router from '@/router' //引入路由
import store from '@/store'
import {
  getToken
} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import {
  Toast,
  Dialog
} from 'vant' //引入提示层
import router from '../router'
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 60 * 1000
})

// 全局池
const routeRequestPool = []
// 取消路由切换时请求
export function cancelRouteRequests() {
  routeRequestPool.forEach(c => c.abort())
  routeRequestPool.length = 0
}

// 2.请求拦截器
service.interceptors.request.use(config => {
  // 只有明确声明的，才参与路由切换 cancel
  if (config.cancelOnRouteLeave === true) {
    const controller = new AbortController()
    config.signal = controller.signal
    routeRequestPool.push(controller)
  }
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  let TOKEN = getToken();
  if (TOKEN && !isToken) {
    if (!TOKEN.startsWith('Bearer')) {
      TOKEN = 'Bearer ' + TOKEN;
    }
    config.headers['Authorization'] = TOKEN; // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.msg || res.data.msg || errorCode['default']
    if (code === 401 || code === '401') {
      Dialog.confirm({
        title: '系统提示',
        message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          // location.href = '/index';
          router.push('/login')
          location.reload() // 为了重新实例化vue-router对象 避免bug
          // window.location.replace(`/login?t=${Date.now()}`);
        })
      })
    } else if (code === 500 || code === '500') {
      // 若请求配置了 skipDefaultErrorToast，则不弹出默认提示，由调用方自行处理
      if (!res.config.skipDefaultErrorToast) {
        Toast.fail(msg);
      }
      return Promise.reject(new Error(msg))
    } else {
      return res.data
    }
  },
  error => {
    if (isCanceled(error)) {
      return Promise.reject(error)
    }

    // 若请求配置了 skipDefaultErrorToast，不弹出通用异常提示，由调用方自行处理
    if (error.config?.skipDefaultErrorToast) {
      return Promise.reject(error)
    }

    let {
      message
    } = error;
    if (message == "Network Error") {
      message = "当前网络不稳定，请稍后再试。";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Toast({
      message: message,
      type: 'fail',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

function isCanceled(error) {
  return (
    error?.name === 'CanceledError' ||
    error?.code === 'ERR_CANCELED' ||
    error?.message === 'canceled'
  )
}

//4.导入文件
export default service